import axios from 'axios'

var baseURL = 'https://app.lexuetiyu.com/';

// 地址
export function baseUrl() {
	return baseURL
}

// 在开发环境中的测试 development
if(process.env.NODE_ENV == 'development') {
	axios.defaults.baseURL = baseURL
}
// 在生产环境中的测试 production
if(process.env.NODE_ENV == 'production') {
	axios.defaults.baseURL = baseURL
}
// 打包环境
if(process.env.NODE_ENV == 'debug') {
	axios.defaults.baseURL = baseURL
}

//响应超时的时间
axios.defaults.timeout = 5000;

//接口请求拦截
axios.interceptors.request.use(
	config => {
		config.header = {
			// 响应首部，用于预检请求中，代表将会在正式请求的Access-Control-Expose-Headers 字段中出现的首部信息
            // 'Access-Control-Allow-Headers': 'Content-Type, Content-Length, Authorization, Accept, X-Requested-With , yourHeaderFeild',
            "Content-Type": "application/x-www-form-urlencoded;multipart/form-data;application/json;charset=utf-8",
			'Access-Control-Allow-Origin': '*',
			"Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
			"Access-Control-Allow-Methods": "PUT,POST,GET,DELETE,OPTIONS"
        } //设置响应头部
		return config
	}
)

// // 响应拦截器
// axios.interceptors.response.use(    
//     response => {        
//         if (response.status === 200) {            
//             return Promise.resolve(response);        
//         } else {            
//             return Promise.reject(response);        
//         }    
//     },
//     // 服务器状态码不是200的情况    
//     error => {        
//         if (error.response.status) {            
//             switch (error.response.status) {                
//                 // 401: 未登录                
//                 // 未登录则跳转登录页面，并携带当前页面的路径                
//                 // 在登录成功后返回当前页面，这一步需要在登录页操作。                
//                 case 401:                    
//                     router.replace({                        
//                         path: '/login',                        
//                         query: { redirect: router.currentRoute.fullPath } 
//                     });
//                     break;
//                 // 403 token过期                
//                 // 登录过期对用户进行提示                
//                 // 清除本地token和清空vuex中token对象                
//                 // 跳转登录页面                
//                 case 403:                     
//                     Toast({                        
//                         message: '登录过期，请重新登录',                        
//                         duration: 1000,                        
//                         forbidClick: true                    
//                     });                    
//                     // 清除token                    
//                     localStorage.removeItem('token');                    
//                     store.commit('loginSuccess', null);                    
//                     // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
//                     setTimeout(() => {                        
//                         router.replace({                            
//                             path: '/login',                            
//                             query: { 
//                                 redirect: router.currentRoute.fullPath 
//                             }                        
//                         });                    
//                     }, 1000);                    
//                     break; 
//                 // 404请求不存在                
//                 case 404:                    
//                     Toast({                        
//                         message: '网络请求不存在',                        
//                         duration: 1500,                        
//                         forbidClick: true                    
//                     });                    
//                 break;                
//                 // 其他错误，直接抛出错误提示                
//                 default:                    
//                     Toast({                        
//                         message: error.response.data.message,                        
//                         duration: 1500,                        
//                         forbidClick: true                    
//                     });            
//             }            
//             return Promise.reject(error.response);        
//         }       
//     }
// );

// post
export function get(url,params){
	return new Promise((resolve,reject) => {
		axios.get(url,{
			params : params
		}).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	})
}


// get方法
export function post(url, params){
	return new Promise((resolve,reject) => {
		axios.post(url, params)
		.then(res => {
			resolve(res.data)
		})
		.catch(err => {
			reject(err.data)
		})
	})
}

// post
export function postFile(url,params){
	return new Promise((resolve,reject) => {
		axios.get(url,{
			data : params
		}).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	})
}


// WEBPACK FOOTER //
// ./src/request/request.js